import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import Image from '../image/Image';
import GenericHeader from '../pageHeader/GenericHeader';

//Constants
import { configs } from '@constants/configs/configs';

export default function Fallback({ logout, stateCode }) {
    const { anonymous, impersonation } = useSelector(state => state.common.environment);
    const isLoggedIn = !anonymous && !impersonation;
    const state = stateCode.toLowerCase();
    const errorImage = configs.ENV.DEVELOPMENT ? `../../../assets/images/${state}-error-illustration.png` : configs.endpoints.IMAGES.processReplacements({ relativePath: '/resources/img', fileName: `${state}-error-illustration.png` });
    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section" id="gi-fallback__container">
                <div className="grid-container gi-grid-container">
                    <div className="grid-row grid-gap gi-wrapper gi-fallback">
                        <div className="desktop:grid-col-4 tablet:grid-col-4 mobile:grid-col-12 gi-fallback__item gi-fallback__content">
                            <GenericHeader
                                tag="h1"
                                id="error-header"
                                text="session.error.header"
                                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__header']}
                            />
                            {!isLoggedIn && (
                                <GenericHeader
                                    tag="p"
                                    id="error-contet"
                                    text="session.error.content"
                                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__msg']}
                                    linkClassName={['usa-link gi-fallback__content__link']}
                                    isReplacementALink={ true }
                                    path={logout}
                                    linkText="session.error.content.link.text"
                                />
                            )}
                        </div>
                        <div className="desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__item gi-fallback__img">
                            <Image
                                { ...
                                    {
                                        source: errorImage,
                                        desc: 'session.error.content.img.desc',
                                        name: 'system__error_img',
                                        classes: []
                                    }
                                }
                            />
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
}